import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { withTranslation } from 'react-i18next'
import { Grid, FormControlLabel, Switch } from '@material-ui/core';
import PublicPage from '../PublicPage';
import Typo from '../../components/CustomTypo';
import { portalCfg } from '../../../portal.router.config';
import Button from '../../components/ButtonCustom';
import { LinkRouter } from '../../components/Link';
import { Field, Form } from 'react-final-form';
import { TextFieldComponent, TextFieldWithSelectComponent } from '../../components/FormElement';
import validators from '../../utils/validators';
import SocialComponent from '../../components/SocialComponent'
import { RadioCheckedIcon, RadioIcon, SwichGreenActiveIcon, SwichIcon } from '../../components/icons'
import countries from '../../../countries';
import { domainName } from '../../../portal.config';

const lang_icon_en = portalCfg.publicPath + "/icons/usa_flag.png";

const styles = theme => ({
    container: {
        paddingTop: theme.spacing(10),
        paddingBottom: theme.spacing(10),
        [theme.breakpoints.down('sm')]: {
            paddingBottom: theme.spacing(2),
        },
    },
    marginTop: {
        marginTop: theme.spacing(2),
    },
    marginTop2x: {
        marginTop: theme.spacing(10),
    },
    marginTop4x: {
        marginTop: theme.spacing(20),
    },
    formLogin: {
        marginTop: theme.spacing(4),
        backgroundColor: theme.palette.background.box,//'#ffffff1f',
        borderRadius: 10,
        padding: theme.spacing(5, 15, 10, 15),
    },
    form_select:{
        marginTop: theme.spacing(4),
        cursor: 'pointer'
    },
    swichSmall: {
        marginTop: theme.spacing(2),
        resizeMode: 'contain',
        cursor: 'pointer'
    }
});
function IdentifyView(props){
    const { classes, t, showAlert, onShowLoading, register_info, onSelectMethod, onSelectVerify, country_select } = props;
    //console.log('RegisterEmailView auth_support==',auth_support)
    return (
        <PublicPage 
            rightComponent={
                <Grid xs={12} sm={12} md={12} item container>
                    <Grid xs={12} sm={12} item container>
                        <Typo variant='h3' color={domainName =='buyway' ? 'onPrimary' : 'primary'} mg_bottom_md>{t('identify_title')}</Typo>
                    </Grid>
                    <Grid xs={12} item container direction="row">
                        <Typo variant='body2' color={domainName =='buyway' ? 'onPrimary' : 'primary'} center>{t('already_account')}&nbsp;</Typo>
                        <LinkRouter to='login' variant='body2' size='sm' color='primary'>{t('btn_login')}</LinkRouter>
                    </Grid>
                    <Grid xs={12} item container direction="row">
                        <Typo mg_top_xl variant='body1' color={domainName =='buyway' ? 'onPrimary' : 'primary'} center>{t('select_identify')}&nbsp;</Typo>
                    </Grid>
                    <Grid xs={12} sm={12} item container justify='center'>
                    <Form
                        onSubmit={props.onSubmit}
                        render={({ handleSubmit, reset, submitting, pristine, values }) => (
                            <Grid xs={12} container item>
                                <Grid item container alignItems='flex-end' className={classes.form_select} onClick={()=>onSelectMethod('PHONE')}>
                                {props.method_select==='PHONE'?<RadioCheckedIcon/>:<RadioIcon/>}<Typo mg_left_xs color='label' variant='body2'>{t("phone_number")}</Typo>
                                </Grid>
                                {props.method_select==='PHONE'&&<Field
                                    name="PHONE"
                                    component={TextFieldWithSelectComponent}
                                    isEdit={true}
                                    validate={validators.composeValidators(validators.mustBeNumber)}
                                    autoFocus={true}
                                    selectData={countries}
                                    defaultValueSelect={country_select}
                                    valueSelect={country_select}
                                    onSelectedChange={props.onSelectCountry}
                                />}
                                <Grid item container alignItems='flex-end' className={classes.form_select} onClick={()=>onSelectMethod('EMAIL')}>
                                {props.method_select==='EMAIL'?<RadioCheckedIcon/>:<RadioIcon/>}<Typo mg_left_xs color='label' variant='body2'>{t("email")}</Typo>
                                </Grid>
                                
                                {props.method_select==='EMAIL'&&<Field
                                    name="EMAIL"
                                    component={TextFieldComponent}
                                    placeholder={t('email_input_placeholder')}
                                    isEdit={true}
                                    color='default'
                                    validate={validators.composeValidators(validators.validEmail)}
                                    autoFocus={true}
                                />}
                                <Grid item container alignItems='flex-end' className={classes.form_select} onClick={()=>onSelectMethod('LOYALTY_IDENTIFIER')}>
                                    {props.method_select==='LOYALTY_IDENTIFIER'?<RadioCheckedIcon/>:<RadioIcon/>}<Typo mg_left_xs color='label' variant='body2'>{t("loyalty_card")}</Typo>
                                </Grid>

                                {props.method_select==='LOYALTY_IDENTIFIER'&&<Field
                                    name="LOYALTY_IDENTIFIER"
                                    component={TextFieldComponent}
                                    placeholder={t('card_input_placeholder')}
                                    isEdit={true}
                                    color='default'
                                    validate={validators.composeValidators(validators.mustBeNumberRequired)}
                                    autoFocus={true}
                                />}
                                
                                <Typo mg_top_xl color={domainName =='buyway' ? 'onPrimary' : 'primary'} variant='body1' className={classes.marginTop4x}>{t("receive_one_time_password")}</Typo>
                                <Grid item container alignItems='flex-end' className={classes.form_select} onClick={()=>onSelectVerify('EMAIL')}>
                                    {props.verify_type==='EMAIL'?<RadioCheckedIcon/>:<RadioIcon/>}<Typo mg_left_xs color='label' variant='body2'>{t("setting_email")}</Typo>
                                </Grid>
                                <Grid item container alignItems='flex-end' className={classes.form_select} onClick={()=>onSelectVerify('SMS')}>
                                    {props.verify_type==='SMS'?<RadioCheckedIcon/>:<RadioIcon/>}<Typo mg_left_xs color='label' variant='body2'>{t("setting_sms")}</Typo>
                                </Grid>
                                <Grid xs={12} item container justify='center' className={classes.marginTop2x}>
                                    <Button color='primary' fullWidth onClick={handleSubmit}>{t('btn_send_opt')}</Button>
                                </Grid>
                            </Grid>
                        )} />
                    </Grid>
                </Grid>}
        />
    );
}
export default withStyles(styles)(withTranslation()(IdentifyView));